import React from "react";
import Breadcrumbs from "../../components/Breadcrumbs";
import { useState } from "react";
import SortableTable from "../SortableTable";
import NoRecordsAvailable from "../NoRecordsAvailable";
import { displayFormatDate } from "../../utils/helpers";
import { useProjectDesignationOptions } from "../../Hooks/useProjectDesignationOptions";
const TeamMembers = ({ project }) => {
  const { options: designationOptions } = useProjectDesignationOptions();
  const columns = [
    { key: "name", label: "Employee Name" },
    {
      key: "designation",
      label: "Designation",
      render: (item) => {
        const option = designationOptions.find(
          (opt) => opt.value === item.designation
        );
        return option ? option.label : "-";
      },
    },
    {
      key: "expertise",
      label: "Project Expertise",
      render: (item) => item.expertise?.trim() || "-",
    },
    {
      key: "joinDate",
      label: "Joining Date",
      compare: (a, b) => new Date(a.joinDate) - new Date(b.joinDate),
      render: (item) => displayFormatDate(item.joinDate),
    },
    {
      key: "endDate",
      label: "End Date",
      compare: (a, b) => new Date(a.endDate || 0) - new Date(b.endDate || 0),
      render: (item) => displayFormatDate(item.endDate),
    },
    {
      key: "status",
      label: "Status",
      render: (item) => {
        switch (item.status) {
          case 0:
            return "Inactive";
          case 1:
            return "Active";
          case 2:
            return "Deallocated";
          default:
            return item.status || "-";
        }
      },
    },
  ];
  return (
    <>
      {project.members && project.members.length > 0 ? (
        <SortableTable
          columns={columns}
          data={project.members}
          className="mb-3"
        />
      ) : (
        <NoRecordsAvailable />
      )}
    </>
  );
};

const ShadowTeamMembers = ({ project }) => {
  const { options: designationOptions } = useProjectDesignationOptions();
  const columns = [
    {
      key: "shadowEmployee",
      label: "Shadow Employee",
      render: (item) => item.shadowEmployeeName,
    },
    {
      key: "mainEmployee",
      label: "Main Employee",
      render: (item) => item.workingEmployeeName,
    },
    {
      key: "designation",
      label: "Shadow Resource Designation",
      render: (item) => {
        const normalizedDesignation = item.designation
          ?.toLowerCase()
          .replace(/_/g, " ");
        const option = designationOptions.find((opt) => {
          const label = opt.label.toLowerCase();
          const value = opt.value.toLowerCase().replace(/_/g, " ");
          return (
            label === normalizedDesignation || value === normalizedDesignation
          );
        });
        return option ? option.label : item.designation || "-";
      },
    },
    {
      key: "expertise",
      label: "Project Expertise",
      render: (item) => item.expertise?.trim() || "-",
    },
    {
      key: "joiningDate",
      label: "Joining Date",
      compare: (a, b) => new Date(a.joiningDate) - new Date(b.joiningDate),
      render: (item) => displayFormatDate(item.joiningDate),
    },
    {
      key: "endDate",
      label: "End Date",
      compare: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      render: (item) => displayFormatDate(item.endDate),
    },
    {
      key: "status",
      label: "Status",
      render: (item) => {
        switch (item.status) {
          case 1:
            return "Active";
          case 0:
            return "Inactive";
          case 2:
            return "Deallocated";
          default:
            return item.status || "-";
        }
      },
    },
  ];
  return (
    <>
      {project.shadowMembers && project.shadowMembers.length > 0 ? (
        <SortableTable
          columns={columns}
          data={project.shadowMembers}
          className="mb-3"
        />
      ) : (
        <NoRecordsAvailable />
      )}
    </>
  );
};
const DisplayMembersTableTabs = ({ project }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const tabs = [
    { label: "Team Members", component: TeamMembers },
    { label: "Shadow Team Members", component: ShadowTeamMembers },
  ];
  return (
    <div className="wrapper-body py-0">
      <div className="border p-3 rounded-lg">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <ul className="nav nav-tabs" role="tablist">
            {tabs.map((item, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link ${
                    activeTabIndex === index ? "active" : ""
                  }`}
                  type="button"
                  role="tab"
                  aria-selected={activeTabIndex === index}
                  onClick={() => setActiveTabIndex(index)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="tab-content mt-3
        "
        >
          {tabs.map((item, index) => {
            const Component = item.component;
            return (
              activeTabIndex === index && (
                <div
                  key={index}
                  className={`tab-pane fade show active`}
                  role="tabpanel"
                >
                  <Component project={project} />
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default DisplayMembersTableTabs;
